var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWifiX = function SvgIconWifiX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.058 9.916a12.65 12.65 0 0 1 8.929-3.666l.738.018a1 1 0 0 0 .05-1.999l-.75-.019h-.022A14.65 14.65 0 0 0 1.65 8.496a1 1 0 1 0 1.409 1.42M21.707 5.957a1 1 0 0 0-1.414-1.414L18.75 6.086l-1.543-1.543a1 1 0 1 0-1.414 1.414L17.336 7.5l-1.543 1.543a1 1 0 0 0 1.414 1.414l1.543-1.543 1.543 1.543a1 1 0 0 0 1.414-1.414L20.164 7.5zM9.401 16.294a3.753 3.753 0 0 1 5.197 0 1 1 0 1 0 1.384-1.444 5.753 5.753 0 0 0-7.965 0A1 1 0 1 0 9.4 16.294M11.996 10.75a8.17 8.17 0 0 0-5.763 2.347 1 1 0 0 1-1.403-1.425 10.17 10.17 0 0 1 7.172-2.922zM13.5 18.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconWifiX;